import React, { useState } from "react";
import Select from "react-select";
import Offcanvas from "react-bootstrap/Offcanvas";

const Container = () => {
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const handleShowAdd = (e) => {
    e.preventDefault();
    setShowAdd(true);
  };

  const handleShowEdit = (e) => {
    e.preventDefault();
    setShowEdit(true);
  };

  const handleCloseAdd = () => setShowAdd(false);
  const handleCloseEdit = () => setShowEdit(false);

  return (
    <>
      <form>
        <div className="card">
          <div className="card-body">
            <div className="row">
            <div className="col-md-6">
              <div className="ms-2">
                <label htmlFor="" className="form-label  mb-0">
                  Bank
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <select className="form-control form-control-sm">
                    <option></option>
                    <option>Loose</option>
                    <option>ULD</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ms-2">
                <label htmlFor="" className="form-label  mb-0">
                  Remittance Details
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ms-2">
                <label htmlFor="" className="form-label  mb-0">
                  Payment Link
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Container;
